// src/utils/supabase.js
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY

let tokenStore = null

export function setSupabaseToken(token) {
  tokenStore = token
}

const supabase = createClient(supabaseUrl, supabaseKey, {
  accessToken: async () => tokenStore,
})

export default supabase
